import { Controller } from "@hotwired/stimulus"

// Автоматически обновляет страницу пока статус аттестации queued или processing
export default class extends Controller {
  static values = {
    url:      String,
    interval: { type: Number, default: 5000 }
  }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.timer = setInterval(() => {
      this.checkStatus()
    }, this.intervalValue)
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  checkStatus() {
    // Перезагружаем страницу через Turbo для получения актуального статуса
    fetch(this.urlValue, {
      headers: { "Accept": "text/html", "X-Requested-With": "XMLHttpRequest" }
    })
      .then(response => response.text())
      .then(html => {
        // Проверяем новый статус из ответа
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const newBadge = doc.querySelector("[data-attestation-status-badge]")
        const currentBadge = this.element.querySelector("[data-attestation-status-badge]")

        if (newBadge && currentBadge) {
          const newStatus = newBadge.textContent.trim()
          const currentStatus = currentBadge.textContent.trim()

          if (newStatus !== currentStatus) {
            // Статус изменился — перезагружаем страницу
            window.location.reload()
          }
        }
      })
      .catch(err => console.error("Ошибка polling статуса аттестации:", err))
  }
}
